import * as Sentry from '@sentry/browser';

export function captureTrackingError(error: unknown, collectionId: number, endpoint: string): void {
  Sentry.captureException(error, {
    tags: { feature: 'movie-rating', endpoint },
    extra: { collectionId },
  });
}
